import Upsertable from '@/models/Upsertable'
import { useAgreementTermStore } from '@/stores/agreementTermStore'
import { useUserStore } from '@/stores/userStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgreementTerm extends Upsertable {
  static store() {
    return useAgreementTermStore()
  }

  store() {
    return AgreementTerm.store()
  }

  static all() {
    return AgreementTerm.store().getAll
  }

  static find(uuid) {
    const obj = AgreementTerm.store().find(uuid)
    let agreement_term = new AgreementTerm()
    return Object.assign(agreement_term, obj)
  }

  static findByUuidAndType(uuid, type) {
    const obj = AgreementTerm.store().findByUuidAndType(uuid, type)
    const userStore = useUserStore()
    let agreement_term = new AgreementTerm(obj?.name, userStore.user)
    return Object.assign(agreement_term, obj)
  }

  constructor(term_name, customer) {
    super()
    this.name = term_name
    this.agree = false
    this.customer_uuid = customer.uuid
  }
}

useModelName(AgreementTerm, "AgreementTerm")
ModelRegistry.register(AgreementTerm, "AgreementTerm")